const Ellipse = ({width, height, color}) => {
  return (
    <svg
      width={width ? width : "373"}
      height={height ? height : "70"}
      viewBox="0 0 373 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="186.5" cy="35" rx="250.5" ry="35" fill={color ? color : "#002133"} />
    </svg>
  );
};

export default Ellipse;
